// @TODO : to be refactored into FP
export class LocalStorageObserver {
  private storageKey: string;
  private callback: (newValue: string | null) => void;
  private currentValue: string | null;

  constructor(key: string, callback: (newValue: string | null) => void) {
    this.storageKey = key;
    this.callback = callback;
    this.currentValue = localStorage.getItem(this.storageKey);

    // Start observing changes
    window.addEventListener('storage', this.handleStorageChange);
  }

  private handleStorageChange = (event: StorageEvent) => {
    if (event.key === this.storageKey) {
      const newValue = event.newValue;
      if (newValue !== this.currentValue) {
        this.currentValue = newValue;
        this.callback(newValue);
      }
    }
  };

  public stopObserving() {
    window.removeEventListener('storage', this.handleStorageChange);
  }
}
